<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-user-transaction-point">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4 style="text-align: left;" class="m-0">
              User Transaction Report
            </h4>
            <h6 style="text-align: right;">Total Points: {{ this.totalPoints.toFixed(2) }}</h6>
            <p class="m-0" style="text-align: right;">{{ TransactionReportItems.length }} records displayed</p>
            <br />
            <!-- <hr /> -->
            <div class="row mt-1">
              <div class="col-sm-6 col-md-6">
                <b-input-group prepend="Name">
                  <b-form-input disabled :value="userDetail.name"></b-form-input>
                </b-input-group>
              </div>
              <div class="col-sm-6 col-md-6">
                <b-input-group prepend="User Name">
                  <b-form-input :value="userDetail.username" disabled></b-form-input>
                </b-input-group>
              </div>
            </div>
            <div class="row mt-4 align-items-center">
              <div class="col-sm-6 col-md-6 d-flex align-items-center">
                <label class="mb-0" style="white-space: nowrap;">Show</label>
                <select class="form-control ml-1 mr-1" style="width: 40%;" v-model="pageSize">
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
                <label class="mb-0" style="white-space: nowrap;">Entries</label>
              </div>
              <div class="col-sm-6 col-md-6" style="text-align: right">

                <!-- EDIT -->
                <router-link
                  v-if="canEditAndPoints"
                  class="btn btn-primary btn-lg btn-sm-block mr-2"
                  :to="{
                    name: 'AdminUserManagerEditUser',
                    params: { userId: this.$route.params.userId },
                  }"
                >
                  Edit
                </router-link>

                <!-- POINTS -->
                <router-link
                  v-if="canEditAndPoints"
                  class="btn btn-primary btn-lg btn-sm-block mr-2"
                  :to="{
                    name: 'AdminUserManagerPoints',
                    params: { userId: this.$route.params.userId },
                  }"
                >
                  Points
                </router-link>

                <!-- USER MANAGER (always visible) -->
                <router-link
                  class="btn btn-primary btn-lg btn-sm-block mr-2"
                  :to="{ name: 'AdminUserManager' }"
                >
                  User Manager
                </router-link>

              </div>

            </div>
            <div class="table-responsive">
              <a-table
                :columns="TransactionReportFields"
                :data-source="TransactionReportItems"
                :pagination="pagination"
                :loading="loading"
                @change="handleTableChange"
                bordered
                :row-key="(record) => record.id"
                class="transactionTable"
              >
                <span slot="comments" slot-scope="text, record">
                  <span v-html="record.comments"></span>
                </span>
                <span slot="date" slot-scope="text, record">
                  {{ moment(record.date).format('MM/DD/YYYY hh:mm A') }}
                </span>
                <span slot="dollars" slot-scope="text, record">
                  <p>
                    {{
                      record.type.toLowerCase() === 'order' ||
                      record.type.toLowerCase() === 'points subtracted' ||
                      record.type.toLowerCase() === 'order tax'
                        ? '-'
                        : ''
                    }}
                    {{
                      record.dollars
                        ? parseInt(record.dollars)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                        : '0.00'
                    }}
                  </p>
                </span>
                <span slot="points" slot-scope="text, record">
                  <span
                    v-if="
                      record.points < 0 ||
                        record.type.toLowerCase() === 'order' ||
                        record.type.toLowerCase() === 'points subtracted' ||
                        record.type.toLowerCase() === 'order tax'
                    "
                    class="badge badge-danger pl-1 pr-1"
                    >-{{
                      record.points
                        ? parseInt(record.points)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                        : '0.00'
                    }}</span
                  >
                  <span v-else class="badge badge-success pl-1 pr-1">{{
                    record.points
                      ? parseInt(record.points)
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                      : '0.00'
                  }}</span>
                </span>
              </a-table>
            </div>
            <div class="d-flex justify-content-between mt-2">
                <div>
                  <span v-if="TransactionReportItems.length === 0"
                    >Showing 0 to 0 of 0 entries</span
                  >
                  <span v-else
                    >Showing
                    {{
                      (PageNo - 1) *
                        pageSize +
                      1
                    }}
                    to
                    {{ PageNo * pageSize }}
                    of
                    {{ pagination.total }} entries</span
                  >
                </div>
                <div v-if="TransactionReportItems.length > 0">
                  <pagination
                    :data="TransactionReportItems"
                    :totalPages="
                      Math.ceil(
                        pagination.total /
                          pageSize
                      )
                    "
                    :total="pagination.total"
                    :perPage="pageSize"
                    :currentPage="PageNo"
                    @pagechanged="onPageChange"
                  />
                </div>
              </div>
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import AdminSidebar from '@/views/admin/AdminSidebar.vue';
import { mapState } from 'vuex';
import Pagination from "@/components/Pagination.vue";

import moment from 'moment';

function decodeJWT(token) {
  if (!token) return null;

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

export default {
  name: 'TransactionReport',
  props: {
    userId: Number,
  },
  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    pagination: Pagination,
  },

  data() {
    return {
      sortField: '',
      sortOrder: '',
      pagination: {
        showTotal: (total, range) => (
          <div>
            <div>
              {range[0]}-{range[1]} of {total} items
            </div>
            <li class="pagination-item" title="First Page">
              <button type="button" class="btn btn-primary" disabled={this.pagination.current === 1} onClick={() => this.goToPage(1)}>
                <font-awesome-icon icon="angle-double-left" class="m-0" />
              </button>
            </li>
          </div>
        ),
        itemRender: (current, type, originalElement) => {
          const goToNextPage = () => this.goToPage(this.pagination.current + 1);
          const totalPages = Math.ceil(this.pagination.total / this.pagination.pageSize);
          if (type === 'next') {
            return (
              <div class="next-buttons" onClick={(e) => e.stopPropagation()}>
                <li class="pagination-item">
                  <button type="button" class="btn btn-primary" disabled={totalPages === this.pagination.current} onClick={goToNextPage}>
                    <font-awesome-icon icon="angle-right" class="m-0" />
                  </button>
                </li>
                <li class="pagination-item" title="Last Page">
                  <button
                    type="button"
                    class="btn btn-primary"
                    disabled={totalPages === this.pagination.current}
                    onClick={() => this.goToPage(totalPages)}
                  >
                    <font-awesome-icon icon="angle-double-right" class="m-0" />
                  </button>
                </li>
              </div>
            );
          }
          return originalElement;
        },
        hideOnSinglePage: true,
      },
      loading: false,
      pageSize: 5,
      TransactionReportFields: [
        {
          title: 'Client Name',
          key: 'client_name',
          dataIndex: 'client_name',
          sorter: true,
        },
        {
          title: 'Date',
          key: 'date',
          dataIndex: 'date',
          scopedSlots: { customRender: 'date' },
          sorter: true,
        },
        {
          title: 'Type',
          key: 'type',
          dataIndex: 'type',
          sorter: true,
        },
        {
          title: 'By Whom',
          key: 'by_whom_user_name',
          dataIndex: 'by_whom_user_name',
          sorter: true,
        },

        {
          title: 'Dollars',
          key: 'dollars',
          dataIndex: 'dollars',
          scopedSlots: { customRender: 'dollars' },
          sorter: true,
          align: 'right',
        },
        {
          title: 'Points',
          key: 'points',
          dataIndex: 'points',
          scopedSlots: { customRender: 'points' },
          sorter: true,
          align: 'right',
        },
        {
          title: 'Order Number',
          key: 'order_number',
          dataIndex: 'order_number',
          sorter: true,
        },
        {
          title: 'Product',
          key: 'product',
          dataIndex: 'product',
          sorter: true,
        },
        {
          title: 'Program',
          key: 'program',
          dataIndex: 'program',
          sorter: true,
        },
        {
          title: 'Comments',
          key: 'comments',
          dataIndex: 'comments',
          scopedSlots: { customRender: 'comments' },
        },
      ],
      TransactionReportItems: [],
      totalPoints: null,
      PageNo: 1,
    };
  },
  watch: {
    pageSize() {
      this.pagination.current = 1;
      this.getTransactionsData({
        pageSize: this.pageSize,
        current: 1,
        sortField: '',
        sortOrder: '',
      });
    },
  },
  computed: {
    ...mapState({
      userDetail: (state) => state.userManager.userDetail,
    }),
    loggedInUserId() {
      const token = localStorage.getItem("jwtToken");
      const payload = decodeJWT(token);
      return payload?.user_id || null;
    },

    canEditAndPoints() {
      // ✅ Only this user can Edit / Add Points
      return this.loggedInUserId !== 736036;
    },
  },
  created() {
    console.log('[TransactionReport] loggedInUsername =', this.loggedInUsername);

    this.$store.dispatch('userManager/fetchUserDetailsById', {
      userId: this.userId,
    });
    this.getTransactionsData({
      pageSize: this.pageSize,
      current: 1,
      sortField: '',
      sortOrder: '',
    });
  },
  destroyed() {
    if (this.$route.name === 'AdminUserManager') {
    } else {
      this.$store.commit('userManager/SET_FILTER_DATA_FOR_USER_MANAGER', {
        companyId: 0,
        userType: 0,
        status: 2,
        recordsPerScreen: 5,
        search: '',
      });
    }
  },
  methods: {
    goToPage(page) {
      const pager = { ...this.pagination };
      pager.current = page;
      this.pagination = pager;
      this.getTransactionsData({
        pageSize: this.pagination.pageSize,
        current: page,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
      });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.sortField = sorter.field ?? '';
      this.sortOrder = sorter.order ?? '';
      this.getTransactionsData({
        pageSize: pagination.pageSize,
        current: pagination.current,
        sortField: sorter.field ?? '',
        sortOrder: sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : '',
      });
    },
    getTransactionsData(params) {
      console.log({params})
      this.loading = true;
      this.$store
        .dispatch('userManager/getUserTransactions', {
          ...params,
          pg_size: this.pageSize,
          userId: this.userId,
        })
        .then(({ data }) => {
          const pagination = { ...this.pagination };
          pagination.total = data.totalRecords;
          pagination.pageSize = this.pageSize;
          this.loading = false;
          this.TransactionReportItems = data.Result;
          this.totalPoints = data.totalPoints;
          this.pagination = pagination;
        });
    },
    onPageChange(page) {
      console.log("page changed", page);
      this.PageNo = page;
      this.getTransactionsData({
        pageSize: this.pageSize,
        current: 1,
        sortField: '',
        sortOrder: '',
        current: this.PageNo
      });
    },

    prevPagination: function () {
      this.PageNo--;
      this.onChangeRecordsPerScreen();
    },

    nextPagination: function () {
      this.PageNo++;
      this.onChangeRecordsPerScreen();
    },
  },
};
</script>

<style lang="scss">
.admin-user-transaction-point {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
  .transactionTable {
    margin-top: 2%;
  }
  .ant-table-thead > tr > th {
    color: black;
    background: #f0f9ff !important;
  }
}
</style>
